import React from 'react';

const ScreenSmallSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="M7 3h10v1H7V3zm0 2h10v12H7V5zm0 13h10v3H7v-3zM6 2v20h12V2H6z" />
        <path d="M11 19h2v1h-2z" />
    </svg>
);

ScreenSmallSvg.displayName = 'ScreenSmallSvg';
export default ScreenSmallSvg;
